// Blackout Scripts — small client behavior

// Tier picker: highlight selected radio in PDP
document.addEventListener('change', function(e){
  if (e.target.name === 'id' && e.target.closest('.pdp-tiers')){
    document.querySelectorAll('.pdp-tiers .tier').forEach(function(t){ t.classList.remove('active'); });
    e.target.closest('.tier').classList.add('active');
  }
});

// Update cart count after add-to-cart (theme-soft fetch)
document.addEventListener('submit', function(e){
  var form = e.target;
  if (form.matches('form[action="/cart/add"]')){
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        var c = document.getElementById('cart-count');
        if (c) c.textContent = cart.item_count;
        window.location.href = '/cart';
      })
      .catch(function(){ form.submit(); });
  }
});
